import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('CMS')
    .setRoute('cms_page_list')
    .setAdditionalRoutes(['cms_page_create', 'cms_page_edit']);
